import { FC, useCallback, useMemo } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../store/hooks";
import { commitmentsDataViewTabSelector } from "../../../../../../../../store/commitments/selectors/common/view-options/commitmentsDataViewTabSelector";
import { setCommitmentsDataViewTab } from "../../../../../../../../store/commitments/commitmentsSlice";
import { DataViewTab } from "../../../../../../../../store/commitments/utils/types/types";
import { reservationsGranularDataTotalUtilizationSelector } from "../../../../../../../../store/commitments/selectors/reservations/data/granular/totals/reservationsGranularDataTotalUtilizationSelector";
import { reservationsGranularDataTotalCoverageSelector } from "../../../../../../../../store/commitments/selectors/reservations/data/granular/totals/reservationsGranularDataTotalCoverageSelector";
import { CommitmentsTabSwitcher } from "@/components/pages/commtiments/common/components/tag-switcher/CommitmentsTabSwitcher";

export const ReservationsDataGridViewTabs: FC = () => {
  const dispatch = useAppDispatch();

  const tab = useAppSelector(commitmentsDataViewTabSelector);

  const totalUtilization = useAppSelector(
    reservationsGranularDataTotalUtilizationSelector,
  );

  const totalCoverage = useAppSelector(
    reservationsGranularDataTotalCoverageSelector,
  );

  const tabChangeHandler = useCallback(
    (tab: string) => {
      if (!tab) {
        return;
      }

      dispatch(setCommitmentsDataViewTab(tab as DataViewTab));
    },
    [dispatch],
  );
  const tabs = useMemo(() => {
    const coverageLabel = totalCoverage?.percent
      ? `(${totalCoverage?.percent}%)`
      : "";
    const reservationLabel = totalUtilization?.percent
      ? `(Utilization ${totalUtilization?.percent}%)`
      : "";
    return [
      {
        label: `Reservations
             ${reservationLabel}`,
        value: "commitment",
      },
      {
        label: `Coverage ${coverageLabel}`,
        value: "coverage",
      },
    ];
  }, [totalCoverage, totalUtilization]);

  return (
    <CommitmentsTabSwitcher
      tabs={tabs}
      onTabChange={tabChangeHandler}
      value={tab}
    />
  );
};
